const $cart = document.querySelector('.cart');
if($cart) {
    const $cartItems = $cart.querySelectorAll('.product-item');
    const $cartMessage = $cart.querySelector('.cart__test');
    const $cartAllPrice = $cart.querySelectorAll('.price-calc');
    const $priceTotal = $cart.querySelector('.checkout__quantity')
    let countCart = $cartItems.length; 
    
    const calcTotalPrice = (/* option = 0 */) =>{
        let totalPrice = 0;
        $cartAllPrice.forEach(el => {
            totalPrice += parseInt(el.textContent.replace(/\s+/g, '')) /* + option */;

            $priceTotal.textContent = `${totalPrice} ₽`;
            if(totalPrice === 0){
                $priceTotal.textContent = 'Корзина пуста :('
            }
        })
    }

    calcTotalPrice();





    $cartItems.forEach(el => {
        let currentPrice = parseInt(el.querySelector('.price-calc').textContent.replace(/\s+/g, ''));
        el.addEventListener('click', (e) => {
            // let minusPrice = parseInt(e.target.closest('.product-item').querySelector('.price').textContent.replace(/\s+/g, ''));
            if(e.target.nodeName === 'BUTTON' || e.target.classList.contains('ico-trash')){
                e.target.closest('.product-item').remove();
                countCart--;
                e.target.closest('.product-item').querySelector('.price-calc').textContent = 0;
                calcTotalPrice();
                showMessage(countCart);
               
            }

            if(e.target.classList.contains('stepper__btn')){
                let stepperCount = parseInt(el.querySelector('.stepper__input').value)
                el.querySelector('.price-calc').textContent = `${currentPrice * stepperCount} ₽`;
                calcTotalPrice();
            }

        })

        el.addEventListener('change', (e)=> {
            if(e.target.classList.contains('stepper__input')){
                let stepperCount = parseInt(e.target.value)
                el.querySelector('.price-calc').textContent = `${currentPrice * stepperCount} ₽`;
                calcTotalPrice();
            }
        })
    })

    const showMessage = (count) => {
        count > 0 ? $cartMessage.classList.add('cart__test--disable') : $cartMessage.classList.remove('cart__test--disable');
    } 
    showMessage(countCart);




}